module.exports = __webpack_public_path__ + "img/sunshine.3afdfad9.png";